"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tripTypeDetailDeserialize = void 0;
const unwrap_1 = __importDefault(require("../util/unwrap"));
const deserializeObject_1 = __importDefault(require("./deserializeObject"));
const deserializeString_1 = require("./deserializeString");
function tripTypeDetailDeserialize(value) {
    const object = (0, deserializeObject_1.default)(value);
    return {
        invoiceFormulaId: (0, unwrap_1.default)(object.invoiceFormulaId, deserializeString_1.deserializeString),
        payoutFormulaId: (0, unwrap_1.default)(object.payoutFormulaId, deserializeString_1.deserializeString),
    };
}
exports.tripTypeDetailDeserialize = tripTypeDetailDeserialize;
